import { app } from "./serviceLMS";
import { DOWNLOAD_BUNDLE_KPI_REPORT, DOWNLOAD_COURSE_KIP_REPORT, DOWNLOAD_GROUP_KPI_REPORT, DOWNLOAD_USER_KPI_REPORT, GET_COURSE_KPI_REPORT, GET_GROUP_KPI_REPORT, GET_SINGLE_BUNDLE_REPORT, GET_SINGLE_COURSE_REPORT, GET_SINGLE_GROUP_REPORT, GET_SINGLE_USER_REPORT, GET_USER_KPI_REPORT } from "./URLs";
import { downloadExcelFile } from "../assets/commonFunctions/CommonFunction";

export const getSingleUserReport = async (userId) => {
  try {
    const response = await app.get(`${GET_SINGLE_USER_REPORT}${userId}`);
    return response.data.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return null;
    }
    throw error;
  }
};

export const getSingleGroupReport = async (groupId) => {
  try {
    const response = await app.get(`${GET_SINGLE_GROUP_REPORT}${groupId}`);
    return response.data.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return null;
    }
    throw error;
  }
};

export const getSingleCourseReport = async (courseId) => {
  try {
    const response = await app.get(`${GET_SINGLE_COURSE_REPORT}${courseId}`);
    return response.data.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return null;
    }
    throw error;
  }
};

export const getSingleBundleReport = async (bundleId, params = {}) => {
  try {
    const response = await app.get(`${GET_SINGLE_BUNDLE_REPORT}${bundleId}`, { params });
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    }
    return { success: false, data: "Failed to fetch bundle report." };
  } catch (error) {
    return { success: false, data: error?.response?.data?.message || "Error fetching bundle report." };
  }
};

export const getBundleFilterOptions = async (bundleId) => {
  try {
    const response = await app.get(`${GET_SINGLE_BUNDLE_REPORT}${bundleId}/filter-options`);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    }
    return { success: false, data: "Failed to fetch filter options." };
  } catch (error) {
    return { success: false, data: error?.response?.data?.message || "Error fetching filter options." };
  }
};

export const downloadBundleReport = async (bundleId) => {
  try {
    const response = await app.get(`${GET_SINGLE_BUNDLE_REPORT}${bundleId}/download`, {
      responseType: "blob",
    });
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    }
    return { success: false, data: "Failed to download report." };
  } catch (error) {
    return { success: false, data: error?.response?.data?.message || "Error downloading report." };
  }
};

export const getUserKpiReport = async (page, size, isUserActive, searchText) => {
  try {
    const params = {
      page:page,
      size:size,
      isUserActive,
      search:searchText,
      sortDir:"DESC"
    };

    const response = await app.get(GET_USER_KPI_REPORT, {
      params: params,
    });
    
    return response.data; 
  } catch (error) {
    console.error("Error fetching user KPI report:", error);
    throw error;
  }
};

export const getCourseKpiReport = async (page, size, isCourseActive, searchText) => {
  const res = await app.get(GET_COURSE_KPI_REPORT, {
    params: { page, size, isCourseActive, searchText },
  });

  const { records, total } = res.data.data || {};
  return { records, total };
};

export const getGroupKpiReport = async (page, size, isGroupActive, searchText) => {
  try {
    const params = {
      page,
      size,
      isGroupActive,
    };

    if (searchText && searchText.trim()) {
      params.searchText = searchText.trim();
    }

    const response = await app.get(GET_GROUP_KPI_REPORT, { params });

    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, data: "Failed to fetch group KPI report." };
    }
  } catch (error) {
    return { success: false, data: error?.response?.data?.message || "Error fetching group KPI report." };
  }
};

export const getBundleKpiReport = async (page, size, isBundleActive, searchText) => {
  try {
    const rawResponse = await app.get("user/api/client-api/reports/kpi/bundles", {
      params: { page, size, isBundleActive, search: searchText },
    });
    const response = rawResponse.data;
    if (rawResponse.status === 200 || rawResponse.status === 201) {
      const { content, totalElements } = rawResponse.data.data || {};
      return { 
        success: true, 
        data: { records: content || [], total: totalElements || 0 } 
      };
    } else {
      return {
        success: false,
        data: "Not getting any response from bundle KPI report.",
      };
    }
  } catch (error) {
    const errorMsg = error?.response?.data?.message || error.message;
    return { success: false, data: errorMsg };
  }
};

export const downloadUserKpiReport = async (isUserActive,searchText) => {
  try {
    const params = { isUserActive , search:searchText, sortDir:"DESC" };
    const response = await app.get(
      DOWNLOAD_USER_KPI_REPORT,
      {
        responseType: 'blob',
        params: params,
      }
    );
    downloadExcelFile(response?.data, "Users KPI Report");
    return { success: true, data: "KPI Report downloaded successfully." }
  } catch (error) {
    console.error("Error downloading user KPI report:", error);
    throw error;
  }
};


export const downloadGroupKpiReport = async (
  isGroupActive,
  limit = null,
  searchText
) => {
  try {
    const params = { isGroupActive };
    if (limit) params.limit = limit;
    if (searchText && searchText.trim()) {
      params.searchText = searchText.trim();
    }
    const response = await app.get(DOWNLOAD_GROUP_KPI_REPORT, { params });
    return response.data.data;
  } catch (error) {
    console.error("Error downloading group KPI report:", error);
    throw error;
  }
};

export const downloadBundleKpiReport = async (isBundleActive = true, searchText = "") => {
  try {
    const params = { 
      isBundleActive: isBundleActive, 
      search: searchText, 
      sortDir: "DESC" 
    };

    const response = await app.get(
      DOWNLOAD_BUNDLE_KPI_REPORT,
      {
        responseType: 'blob',
        params: params,
      }
    );
    downloadExcelFile(response?.data, "Bundle KPI Report");

    return { 
      success: true, 
      data: "Bundle KPI Report downloaded successfully." 
    };
  } catch (error) {
    console.error("Error downloading Bundle KPI report:", error);
    throw error;
  }
};

export const getGroupUserKpiReport = async (groupId, page, size, search, sortDir = "DESC") => {
  try {
    const params = { page, size, sortDir };
    if (search && search.trim()) {
      params.search = search.trim();
    }
    const response = await app.get(
      `/user/api/client-api/reports/kpi/user-group/${groupId}`,
      { params }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching group user KPI report:", error);
    return { status: "ERROR", message: error?.message || "Failed to fetch group user KPI report." };
  }
};

export const downloadGroupUserKpiReport = async (groupId, search = "", sortDir = "DESC") => {
  try {
    const params = { sortDir };
    if (search && search.trim()) {
      params.search = search.trim();
    }

    const response = await app.get(
      `/user/api/client-api/reports/kpi/user-group/${groupId}/download`,
      {
        responseType: "blob",
        params,
      }
    );

    downloadExcelFile(response?.data, "Group User KPI Report");

    return {
      success: true,
      data: "Group User KPI Report downloaded successfully.",
    };
  } catch (error) {
    console.error("Error downloading group user KPI report:", error);
    throw error;
  }
};